import React from 'react';

const userContext = React.createContext({
    authenticated: false,
    user: {
        account: null,
        infos: null,
        paymentAllowed: false
    }
});

export default userContext;
